<template>
    <page-content>
        <div slot="header">
            <h4 class="page-title-padding">互评名单设置</h4>
            <div>
                <el-button v-for="item in buttList" :key="item" @click="buttonClick(item)" size="mini" :style="buttsele===item?'background:#409EFF;color:#fff':''">{{item}}</el-button>
                <el-button-group style="margin-left:40px" v-show="flowisOpen[0]">
                    <el-button :loading="buttonLoading[0]" :type="flowisOpen[0] === '关闭' ? 'danger' : 'primary'" size="mini" @click="setFillIn(1)" >{{flowisOpen[0]}}互评填写</el-button>
                    <el-button :loading="buttonLoading[1]" :disabled="disabledFill" :type="flowisOpen[1] === '关闭' ? 'danger' : 'primary'" size="mini" @click="setFillIn(2)">{{flowisOpen[1]}}考核评分表填写</el-button>
                </el-button-group>
            </div>
        </div>
        <!-- <el-divider></el-divider> -->
        <div slot="content">
            <section  v-loading="loading">
                <div class="mutual-box" v-show="buttsele==='同事互评'">
                    <div>
                        <el-button type="primary" size="mini">{{date[0]}}</el-button>
                        <el-table :data="colleaguesTableData" show-summary :sum-text="`共${colleaguesTableData.length}条数据`" border style="width: 500px;margin-top:20px" max-height="780" size="mini">
                            <el-table-column prop="examinee_name" label="被考评人" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <div :style="scope.row.is_mark==1?'color:#f56c6c':''">{{scope.row.examinee_name}}{{scope.row.examinee_status === 0?'(离职)':''}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column  prop="examiner_name" label="考评人" width="230" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-button style="user-select: text;" :disabled="!!scope.row.is_confirmed" type="text" size="mini" @click="staffVisibles(scope,'colleaguesTableData')">{{scope.row.examiner_name?scope.row.examiner_name:'请选择'}}{{scope.row.examiner_status === 0?'(离职)':''}}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column  prop="examiner_name" label="是否已互评" width="150" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <i :class="scope.row.is_confirmed==1?'el-icon-check':'el-icon-close'"></i>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div style="margin-left:50px">
                        <el-button type="primary" size="mini">{{date[1]}}</el-button>
                        <el-table :data="colleaguesTableData_next" show-summary :sum-text="`共${colleaguesTableData_next.length}条数据`" border style="width: 500px;margin-top:20px" max-height="780" size="mini">
                            <el-table-column prop="examinee_name" label="被考评人" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <div :style="scope.row.is_mark==1?'color:#f56c6c':''">{{scope.row.examinee_name}}{{scope.row.examinee_status === 0?'(离职)':''}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column  prop="examiner_name" label="考评人" width="230" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-button style="user-select: text;" type="text" size="mini" @click="staffVisibles(scope,'colleaguesTableData_next')">{{scope.row.examiner_name?scope.row.examiner_name:'请选择'}}{{scope.row.examiner_status === 0?'(离职)':''}}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div v-show="buttsele==='组员评组长'">
                    <el-button type="primary" size="mini">{{date[0]}}</el-button>
                    <el-table :data="teamLeaderTableData" show-summary :sum-text="`共${teamLeaderTableData.length}条数据`" border style="width: 500px;margin-top:20px" max-height="780">
                        <el-table-column prop="toname" label="被考评人(组长)" header-align="center" align="center">
                            <template slot-scope="scope">
                                <div :style="scope.row.is_mark==1?'color:#f56c6c':''">{{scope.row.examinee_name}}{{scope.row.examinee_status === 0?'(离职)':''}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="组员评组长" width="200" header-align="center" align="center">
                            <template slot-scope="scope">
                                <el-button style="user-select: text;" :disabled="!!scope.row.is_confirmed" type="text" size="mini" @click="staffVisibles(scope,'teamLeaderTableData')">{{scope.row.examiner_name?scope.row.examiner_name:'请选择'}}{{scope.row.examiner_status === 0?'(离职)':''}}</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column  prop="examiner_name" label="是否已互评" width="150" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <i :class="scope.row.is_confirmed==1?'el-icon-check':'el-icon-close'"></i>
                                </template>
                            </el-table-column>
                    </el-table>
                </div>
                <div v-show="buttsele==='组员评专员'">
                    <el-button type="primary" size="mini">{{date[0]}}</el-button>
                    <el-table :data="commissionerTableData" show-summary :sum-text="`共${commissionerTableData.length}条数据`" border style="width: 500px;margin-top:20px" max-height="780">
                        <el-table-column prop="toname" label="被考评人(专员)" header-align="center" align="center">
                            <template slot-scope="scope">
                                <div :style="scope.row.is_mark==1?'color:#f56c6c':''">{{scope.row.examinee_name}}{{scope.row.examinee_status === 0?'(离职)':''}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="组员评专员" width="200" header-align="center" align="center">
                            <template slot-scope="scope">
                                <el-button style="user-select: text;" :disabled="!!scope.row.is_confirmed" type="text" size="mini" @click="staffVisibles(scope,'commissionerTableData')">{{scope.row.examiner_name?scope.row.examiner_name:'请选择'}}{{scope.row.examiner_status === 0?'(离职)':''}}</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column  prop="examiner_name" label="是否已互评" width="150" header-align="center" align="center">
                            <template slot-scope="scope">
                                <i :class="scope.row.is_confirmed==1?'el-icon-check':'el-icon-close'"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </section>
            <staff :visible="staffVisible" @confirmstaff="staffSele" @close="staffVisibles"></staff>
        </div>
    </page-content>
</template>
<script>
import pageContent from '@/components/pageContent'
import staff from '@/components/staff/Staff';
import {currentAssessDate,computeAssessDate} from '@/assets/js/date'
export default {
    data(){
        return{
            date:[],                        //同事互评考核期
            colleaguesTableData:[],
            colleaguesTableData_next:[],
            commissionerTableData: [],
            teamLeaderTableData: [],
            tableData:[],
            buttList:['同事互评','组员评组长','组员评专员'],
            buttsele:'同事互评',
            staffVisible: false,
            currentRow: {},
            currentTable: '',
            flowisOpen:['',''],
            loading:false,
            disabledFill:false,             //考核评分表填写
            buttonLoading:[false,false],
        }
    },
    components:{
        staff,pageContent
    },
    created(){
        this.date=computeAssessDate();
        this.getColleaguesData(this.date[0],'colleaguesTableData');
        this.getColleaguesData(this.date[1],'colleaguesTableData_next');
        this.getTeamLeaderTableData();
        this.getCommissionerTableData();
        this.getIsOpen();
        this.loading=true;
    },
    methods:{
        buttonClick(v){
            this.buttsele=v;
        },
        getColleaguesData(dateArr,tableDataName){
            const date=dateArr.split('/');
            const data={
                start_date:date[0],
                end_date:date[1],
                type: 1
            }
            this.getMutualEvaluationData(data,(res)=>{
                this[tableDataName]=res.data.data;
            },(err)=>{
                console.log(err)
            })
        },
        getTeamLeaderTableData(){
            const date = this.date[0].split('/');
            const data = {
                start_date: date[0],
                end_date: date[1],
                type: 2
            }
            this.getMutualEvaluationData(data,(res)=>{
                this.teamLeaderTableData=res.data.data;
            },(err)=>{
                console.log(err)
            })
        },
        getCommissionerTableData(){
            const date = this.date[0].split('/');
            const data = {
                start_date: date[0],
                end_date: date[1],
                type: 3
            }
            this.getMutualEvaluationData(data,(res)=>{
                this.commissionerTableData=res.data.data;
            },(err)=>{
                console.log(err)
            })
        },
        getMutualEvaluationData(data,resfun,errfun){
            let params = {
                start_date: data.start_date,
                end_date: data.end_date,
                type: data.type
            };
            this.$http.get('mutualEvaluation',{params:params}).then((res)=>{
                if(res.status === 200){
                    if((data.start_date!=this.date[1].split('/')[0] || data.end_date!=this.date[1].split('/')[1])){     //是否已互评完，若没有不开放考核评分表填写
                        res.data.data.forEach(v => {
                            // if(process.env.NODE_ENV === 'production' && v.is_confirmed === 0) this.disabledFill=true;   //‘production’生产环境下
                        });
                    }
                    resfun(res)
                }
                this.loading=false;
            }).catch((err)=>{
                this.loading=false;
                errfun(err)
            })
        },
        staffSele(v,name){
            let params = {
                id: this.currentRow.id,
                examiner_id: v[0],
            }
            if(this.currentRow.examinee_id === v[0]){
                this.$message.error('不可设置被考评人与考评人为同一人！');
                return;
            }
            this.$http.put('mutualEvaluation',params).then((res)=>{
                if(res.status === 200){
                    this.$message({message:res.data.message,type:'success'})
                    if(this.currentTable == 'colleaguesTableData'){
                        this.getColleaguesData(this.date[0],'colleaguesTableData');
                    }else if(this.currentTable == 'colleaguesTableData_next'){
                        this.getColleaguesData(this.date[1],'colleaguesTableData_next');
                    }else if(this.currentTable == 'teamLeaderTableData'){
                        this.getTeamLeaderTableData();
                    }else if(this.currentTable == 'commissionerTableData'){
                        this.getCommissionerTableData();
                    }
                    this.staffVisibles();
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        staffVisibles(scope,tableData){
            if(!this.staffVisible){
                this.currentRow = scope.row;
                this.currentTable = tableData;
            }
            this.staffVisible=!this.staffVisible;
        },
        getIsOpen(index=1){    //判断功能是否开放  1-互评填写 2-考核评分表填写
            const param={
                start:this.date[0].split('/')[0],
                end:this.date[0].split('/')[1],
                department_id:this.$store.state.login.userinfo.department_id,
                flow_type:index,
            }
            this.$http.get('/flow/isOpen',{params:param}).then(v=>{
                if(v.status === 200){
                    const data=v.data;
                    if(index === 1){
                        this.getIsOpen(2);
                    }
                    this.flowisOpen.splice(index-1,1,data.status?'关闭':'开放');
                }
            }).catch(v=>{})
        },
        setFillIn(type){            //填写功能开放设置
            const param={
                start:this.date[0].split('/')[0],
                end:this.date[0].split('/')[1],
                department_id:this.$store.state.login.userinfo.department_id,
                flow_type:type,
            }
            this.setButtonLoading(type)
            if((type === 1 && this.flowisOpen[0] === '开放') || (type === 2 && this.flowisOpen[1] === '开放') ){
                this.setFillInOpen(param,type)
            }else{
                this.setFillInClose(param,type)
            }
            
        },
        setFillInOpen(param,type){   //功能开放设置
            this.$http.put('/flow/open',param).then(v=>{
                if(v.status === 200 && v.data.status){
                    this.flowisOpen.splice(param.flow_type-1,1,'关闭')
                    this.$message({message:v.data.message,type:'success'});
                }
                this.setButtonLoading(type)
            }).catch(v=>{this.setButtonLoading(type)})
        },
        setFillInClose(param,type){   //功能关闭设置
            this.$http.put('/flow/close',param).then(v=>{
                if(v.status === 200){
                    this.flowisOpen.splice(param.flow_type-1,1,'开放')
                    this.$message({message:v.data.message,type:'success'});
                }
                this.setButtonLoading(type)
            }).catch(v=>{this.setButtonLoading(type)})
        },
        setButtonLoading(index){         //关闭，开放loading
            const status=this.buttonLoading[index-1]
            this.buttonLoading.splice(index-1,1,!status)
        },
    }
}
</script>
<style scoped>
    .mutual-box{
        display: flex;
    }
    .el-icon-check,.el-icon-close{
        font-size: 20px;
        color: #f56c6c;
    }
    .el-icon-check{
        /* color: #409EFF; */
        color: #67c23a;
    }
</style>